/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1PlusIcon24Solid = forwardRef('People1PlusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
        React.createElement("path", { d: "M16.06 14.403C14.578 14.053 13.1 14 12 14c-2.985 0-8.736.395-9.821 6.01C1.969 21.093 2.895 22 4 22h11a3 3 0 1 1 0-6h1v-1c0-.204.02-.404.06-.597Z" }),
        React.createElement("path", { d: "M19 14c.69 0 1.25.56 1.25 1.25v2.5h2.5a1.25 1.25 0 1 1 0 2.5h-2.5v2.5a1.25 1.25 0 1 1-2.5 0v-2.5h-2.5a1.25 1.25 0 1 1 0-2.5h2.5v-2.5c0-.69.56-1.25 1.25-1.25Z" })));
});
